export enum GridComponentType {
  ACTION = 'action',
  BADGE = 'badge',
  CHIP = 'chip',
  TEXT = 'text',
  SELECT = 'select',
  DATE = 'date',
  DATETIME = 'datetime',
  LINK = 'link',
  COMMA_SEPERATED = 'comma_separated',
  ADDRESSES = 'addresses',
  CHECKBOX = 'checkbox',
  READONLY_CHECKBOX = 'readonly_checkbox',
}

export const DEFAULT_PAGE_SIZE = 25;
